import React from 'react';
import gql from 'graphql-tag';
import { GET_CHAT, GET_CHATS } from '../../queries';
import { Subscription } from 'react-apollo';

const CHAT_UPDATED_SUB = gql`
  subscription ChatUpdated($token: String!) {
    chatUpdated(token: $token) {
      id
      from
      product {
        id
        name
        image
      }
      lastMessage {
        id
        author {
          id
          firstName
          lastName
          image
        }
        text
        createdAt
      }
      unread
    }
  }
`;

const NewMessagesSub = () => {
  const token = localStorage.getItem('token');

  return (
    <Subscription
      subscription={CHAT_UPDATED_SUB}
      variables={{ token }}
      onSubscriptionData={({ client, subscriptionData: { data } }) => {
        if (!data) return;

        try {
          const cachedChats = client.readQuery({ query: GET_CHATS });
          const filteredChats = cachedChats.userChats.filter(
            chat => chat.id !== data.chatUpdated.id
          );
          const newData = {
            userChats: [data.chatUpdated, ...filteredChats]
          };

          client.writeQuery({ query: GET_CHATS, data: newData });
        } catch {
          // Not queried yet, ignore
        }

        try {
          const cachedChat = client.readQuery({
            query: GET_CHAT,
            variables: { id: data.chatUpdated.id }
          });
          cachedChat.chat.messages.push(data.chatUpdated.lastMessage);
          client.writeQuery({
            query: GET_CHAT,
            variables: { id: data.chatUpdated.id },
            data: cachedChat
          });
        } catch {
          // Not queried yet, ignore
        }
      }}
    />
  );
};

export default NewMessagesSub;
